import type { SVGProps } from "react";
export interface TramIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TramIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TramIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.5 15.627a.62.62 0 0 0-.126.372l.014.126a.6.6 0 0 0 .113.247zm1 .745a.6.6 0 0 0 .112-.247l.014-.126-.014-.126a.6.6 0 0 0-.112-.246zm-7.887-.498a.6.6 0 0 0-.113-.245v.741a.6.6 0 0 0 .113-.245L8.625 16zM7.5 15.629a.62.62 0 0 0-.125.37l.013.126a.6.6 0 0 0 .112.245zM18 .875l.115.006a1.125 1.125 0 0 1 0 2.238L18 3.125h-2.652l-.766 2.684-.038.11a1.126 1.126 0 0 1-1.354.663q-.033-.01-.066-.023v4.317H20l.115.005a1.126 1.126 0 0 1 0 2.239l-.114.006H4a1.125 1.125 0 0 1 0-2.25h6.874V6.559q-.032.012-.065.023a1.125 1.125 0 0 1-1.39-.773L8.65 3.125H6a1.125 1.125 0 0 1 0-2.25zM11.399 4.55a1.12 1.12 0 0 1 1.201 0l.409-1.425h-2.017zM9.625 16a1.626 1.626 0 0 1-3.242.166L6.375 16l.008-.165A1.626 1.626 0 0 1 8 14.375l.166.009c.82.083 1.459.774 1.459 1.615Zm8 0a1.625 1.625 0 0 1-3.242.166L14.376 16l.007-.165A1.626 1.626 0 0 1 16 14.375l.166.009c.82.083 1.458.774 1.459 1.615Z"
      />
      <path
        fill={color}
        d="M18.875 8.5c0-1.035-.84-1.875-1.875-1.875H7c-1.036 0-1.875.84-1.875 1.875V17c0 1.036.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875zm.062 12.877a1.125 1.125 0 0 1-1.873 1.247zM21.125 17a4.12 4.12 0 0 1-2.563 3.815l.375.562-.938.623-.935.624-.998-1.498H7.935l-.998 1.498a1.125 1.125 0 0 1-1.874-1.247l.374-.562A4.12 4.12 0 0 1 2.875 17V8.5A4.125 4.125 0 0 1 7 4.375h10A4.125 4.125 0 0 1 21.125 8.5z"
      />
    </svg>
  );
}
